import { ref, computed } from "vue";
import { useStorage } from "@vueuse/core";
import api from "@/api";

type ConfigKey = {
	lang: any;
	theme: string;
};

const _storageConfig = useStorage<ConfigKey>("session_lang", {
	lang: process.env.VUE_APP_I18N || "fr",
	theme: "dark",
});

// Corrige les valeurs corrompues en localStorage (lang undefined)
if (!_storageConfig.value.lang) {
	_storageConfig.value.lang = process.env.VUE_APP_I18N || "fr";
}

export const storageConfig = _storageConfig;

export const userInfos = ref<any>(null);
export const currentStation = ref<any>({});
export const userID = computed(() => userInfos.value?.account?.id ?? userInfos.value?.id ?? null);
export const enterpriseID = computed(() => userInfos.value?.account?.enterprise_id ?? null);
export const userStats = ref<any>({});
export const stations = ref<any>([]);

// True pendant le bref intervalle où l'utilisateur change d'agence depuis
// le sélecteur du haut. Permet d'afficher un overlay de chargement
// pendant que les pages re-fetch leurs données pour la nouvelle agence.
// On déclenche manuellement depuis AppHeader (pas via watch sur
// currentStation) pour ne pas réagir aux ré-affectations d'init/route.
export const isStationSwitching = ref(false);

// Stub conservé pour compat externe — le sélecteur lit userInfos.stations
// directement. La page « Toutes les agences » filtre côté client par
// userInfos.stations (cf. AgencyOverview). Le drawer continue à charger
// la liste enterprise complète pour la dropdown d'assignation.
export function invalidateEnterpriseStationsCache() {
	/* no-op */
}

export function updateUserInfos(infos: any) {
	console.log('User Infos: ', infos);
	if (infos != null) {
		userInfos.value = infos;
	}
}

export function refreshUserInfos() {
	return new Promise<any>( (resolve, reject) => {
		api()
			.user.getUserInfos()
			.then((userInfos: any) => {
				// Save user infos
				updateUserInfos(userInfos.data);
				resolve("done");
			})
			.catch((err: any) => {
				reject(err);
			});
	});
}

export function resetUserInfos() {
	userInfos.value = null;
}

export function hasStation() {
	return userInfos.value?.stations.length > 1;
}

export function singleStationID() {
	return userInfos.value?.stations[0].id;
}

export function rolesUser() {
	return userInfos.value?.roles;
}

export function singleStationUUID() {
	return userInfos.value?.stations[0].uuid;
}

// strictMode = true; n'integre pas la vue d'ensemble dans le tableau des agences
export async function getAllStationsUser(policy = { strictMode : true}) {

	return new Promise((resolve) => {
		const stations = (userInfos.value?.stations || []).map((station: any) => {
			return { key: station.id, value: station.station_name, uuid: station.uuid };
		});

		if (!policy.strictMode)
			stations.unshift({ key: -1, value: "Vue d'ensemble" })

		resolve(stations ? stations : [])
	})
}

export async function refreshStationsUser() {
	let stations:any = [];
	await refreshUserInfos()
	stations = await getAllStationsUser();
	if (stations.length != 0) {
		currentStation.value = stations[0];
	}
}
